@if (modelDefinition) {
  <h1 mat-dialog-title>{{ modelDefinition.title }}</h1>
  <mat-divider></mat-divider>
  <div mat-dialog-content>
    <agil-mat-table-list
      #assisTable
      [modelDefinition]="modelDefinition"
      [inputValue]="data?.inputValue"
      [queryFilters]="data.queryFilters"
      [allowMultiSelect]="data.allowMultiSelect"
      [parentControl]="data.parentControl"
      [parentType]="data.parentType"
      [hideOpenButton]="true"
      [isAssistant]="true"
      [toggleOnEnter]="false"
      >
    </agil-mat-table-list>
  </div>
}

<div mat-dialog-actions>
  <button
    mat-button
    mat-flat-button
    color="primary"
    [mat-dialog-close]="selectedLines"
    cdkFocusInitial
    >
    <mat-icon>done</mat-icon>
    {{ "OK" }}
  </button>
</div>
